import React, { useState } from "react"
import { Link } from "gatsby"

import TopicList from "./topiclist"

import { convertToSlug } from '../../utils/text'

const topicHref = (topic, platform) => {
  if (platform && platform.slug) {
    return `/topics/${topic.slug}/platform/${platform.slug}/`
  }
  return `/topics/${topic.slug}/`
}

// lists a bunch of topics
const RelatedTopics = ({ relatedTopics, topic, platform, minimalListView = false }) => {
  const initialCount = minimalListView ? 10 : 2
  const [showCount, setShowCount] = useState(initialCount)

  const sortedTopics = [...relatedTopics].sort((a, b) =>
    (a.visitors < b.visitors) ? 1 : ((b.visitors < a.visitors) ? -1 : 0))
  const topics = sortedTopics.filter((t, i) => i < showCount)

  return (
    <section aria-labelledby="related-topics">
      <div className="rounded-lg bg-white overflow-hidden shadow p-6">
        <div className="relative">
          <div className="absolute inset-0 flex items-center" aria-hidden="true">
            <div className="w-full border-t border-gray-200" />
          </div>
          <div className="relative flex items-center justify-between">
            <h2 className="pr-3 bg-white text-lg font-medium text-gray-900">
              {topic.category ? (
                <>
                  Other{" "}
                  <Link
                    to={`/category/${convertToSlug(topic.category)}/`}
                    className="border-b-2 border-rose-400 hover:border-rose-500"
                  >
                    {topic.category}
                  </Link>
                  {" "}Topics
                </>
              ) : (
                "Other Topics"
              )}
            </h2>
          </div>
        </div>
        <div className="mt-2 min-w-0">
          {minimalListView ? (
            <div className="min-w-0 space-y-1">
              {topics.map((t) => {
                const count = t.count
                return (
                  <div key={t.slug} className="min-w-0 text-sm text-gray-900">
                    <Link
                      to={topicHref(t, platform)}
                      className="block min-w-0 truncate font-medium text-gray-800 hover:text-rose-600"
                      title={`${count} ${t.name} Communities`}
                    >
                      <span className="tabular-nums">{count}</span> {t.name} Communities
                    </Link>
                  </div>
                )
              })}
            </div>
          ) : (
            <TopicList topics={topics} mini={true} cols={1} fullWidthMini={true} hideImage={false}
              gridClass={`grid grid-cols-1 sm:grid-cols-3 lg:block lg:space-y-4`}
            />
          )}
        </div>
        {relatedTopics.length > showCount ? (
          <div className="pt-2 mx-auto text-center">
            <button
              type="button"
              className="mx-auto text-gray-600 font-semibold text-xs opacity-75 hover:opacity-100"
              onClick={() => setShowCount(relatedTopics.length)}
            >
              Show {relatedTopics.length - showCount} more →
            </button>
          </div>
        ) : null}
      </div>
    </section>
  )
}

export default RelatedTopics;

